


import React, { useEffect, useState } from "react";
import { TiPlus } from "react-icons/ti";
import { FaEye } from "react-icons/fa";
import { BiSolidEdit } from "react-icons/bi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllPartner, deletePartner, updatePartner } from "../redux/apiCalls/accidentApiCall";
import Pagination from "./Pagination";

function Partner() {
  const dispatch = useDispatch();
  const { accidents, isloading, numberOfAccidents } = useSelector((state) => state.accident);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage] = useState(9);
  const [filters, setFilters] = useState({ name: '', city: '', status: null });
  const [status, setStatus] = useState({});
  const navigate = useNavigate();
  const [sortOrder, setSortOrder] = useState('asc');


  useEffect(() => {
    dispatch(getAllPartner(currentPage, perPage)).then((response) => {
      console.log("API Response:", response); 
    });
  }, [dispatch, currentPage, perPage]);

  const totalPages = Math.ceil((numberOfAccidents || 0) / perPage);
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleAddPartner = () => {
    navigate("/AddPartner");
  };

  const handleView = (id) => {
    navigate(`/partnerEye/${id}`);
  };

  const handleEdit = (id) => {
    navigate(`/partnerEdite/${id}`);
  };

  const handleDelete = (id) => {
    if (window.confirm("Bist du sicher, dass du diesen Partner löschen willst?")) {
      dispatch(deletePartner(id)); 
    }
  };




  const toggleStatus = async(id, currentStatus) => {
    const updatedStatus = !currentStatus; // عكس القيمة الحالية
    const updatedData = {
      isActive: updatedStatus,
    };
  
    await dispatch(updatePartner(id, updatedData, navigate));
    dispatch(getAllPartner(currentPage, perPage));
  };

  const user = JSON.parse(sessionStorage.getItem("user"));



  // const filterPartners = () => {
  //   return (accidents.users || []).filter(partner => {
  //     const matchesName = filters.name ? partner.username.toLowerCase().includes(filters.name.toLowerCase()) : true;
  //     const matchesCity = filters.city ? partner.city.toLowerCase().includes(filters.city.toLowerCase()) : true;
  //     const matchesStatus = filters.status !== null ? partner.isActive === filters.status : true;
  //     return matchesName && matchesCity && matchesStatus;
  //   });
  // };



  const filterPartners = () => {
    if (!accidents.users) return []; // إذا لم تكن موجودة، أعد مصفوفة فارغة لتجنب الأخطاء
    return accidents.users.filter(partner => {
      const matchesName = filters.name ? partner.username?.toLowerCase().includes(filters.name.toLowerCase()) : true;
      const matchesCity = filters.city ? partner.city?.toLowerCase().includes(filters.city.toLowerCase()) : true;
      const matchesStatus = filters.status !== null ? partner.isActive === filters.status : true;
      return matchesName && matchesCity && matchesStatus;
    });
  };
  
  const filteredPartners = filterPartners();

  // Sorting function
  const sortedPartners = [...filteredPartners].sort((a, b) => {
    const nameA = a.username.toLowerCase();
    const nameB = b.username.toLowerCase();
    return sortOrder === 'asc' ? (nameA < nameB ? -1 : 1) : (nameA > nameB ? -1 : 1);
  });

  if (isloading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p>Loading...</p>
      </div>
    );
  }

  console.log("user is ", user);
  

 // ... الكود الحالي

return (
  <div className="flex flex-col w-full h-[100%]">
    {/* Header Section */}
    <div className="flex flex-col w-full">
      <div className="pl-2 md:pl-5 flex flex-col md:flex-row text-center justify-between w-full pt-2 items-center">
        <div className="mb-2 md:mb-0">
          <h1 className="font-montserrat text-xl md:text-2xl font-[900] pt-9 ">Partner Übersicht</h1>
        </div>
        <div className="flex flex-col md:flex-row mr-0 md:mr-5 justify-between w-full md:w-1/3 space-y-2 md:space-y-0">
          <button
            onClick={handleAddPartner}
            className="border border-black bg-yellow-300 rounded-lg w-full md:w-36 h-9 text-sm flex items-center justify-center mx-auto"
          >
            <TiPlus />
            <span className="ml-1">Neue Partner</span>
          </button>
          <div className="flex items-center justify-center md:justify-end">
            <div className="text-center md:text-right">
              <h4 className="text-sm">{user.username}</h4>
              <p className="text-xs text-gray-600">{user.role}</p>
            </div>
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-full border border-gray-800 flex justify-center items-center ml-2">
              <img src={user.profilePhoto?.url} alt="img-pro" className="w-full h-full rounded-[50%]" />
            </div>
          </div>
        </div>
      </div>
      <div className="border-b border-black w-full mt-3"></div>
    </div>

    {/* Filter UI */}
    <div className="flex flex-col md:flex-row justify-between mt-4 space-y-2 md:space-y-0 md:space-x-2 px-2 md:px-0">
      <input
        type="text"
        placeholder="Name"
        value={filters.name}
        onChange={(e) => setFilters({ ...filters, name: e.target.value })}
        className="border border-gray-300 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full md:w-auto"
      />
      <input
        type="text"
        placeholder="Stadt"
        value={filters.city}
        onChange={(e) => setFilters({ ...filters, city: e.target.value })}
        className="border border-gray-300 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full md:w-auto"
      />
      <select
        value={filters.status}
        onChange={(e) => setFilters({ ...filters, status: e.target.value ? JSON.parse(e.target.value) : null })}
        className="border border-gray-300 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full md:w-auto"
      >
        <option value="">alle Status</option>
        <option value="true">Aktiv</option>
        <option value="false">InAktiv</option>
      </select>
      <button 
        onClick={() => setSortOrder(prev => prev === 'asc' ? 'desc' : 'asc')} 
        className="border border-gray-300 p-2 rounded-md w-full md:w-auto"
      >
        Sortieren {sortOrder === 'asc' ? '↑' : '↓'}
      </button>
    </div>

    {/* Table Section */}
    <div className="overflow-x-auto pt-5 px-2 md:px-0">
      <table className="min-w-full border border-gray-300">
        <thead className="bg-gradient-to-b from-[#3a3a3a] to-[#1a1a1a] text-white">
          <tr>
            <th className="px-2 py-2 text-left border-b border-gray-400 text-sm md:text-base">Name</th>
            <th className="px-2 py-2 text-left border-b border-gray-400 hidden md:table-cell">Aktiv seit</th>
            <th className="px-2 py-2 text-left border-b border-gray-400 hidden md:table-cell">anz.Aufträge</th>
            <th className="px-2 py-2 text-left border-b border-gray-400 text-sm md:text-base">Status</th>
            <th className="px-2 py-2 text-left border-b border-gray-400 hidden md:table-cell">Ort</th>
            <th className="px-2 py-2 text-center border-b border-gray-400">Aktion</th>
          </tr>
        </thead>
        <tbody>
          {sortedPartners.length ? (
            sortedPartners.map((partner) => (
              <tr key={partner.id} className="bg-gray-100">
                <td className="px-2 py-2 font-[700] border-b border-gray-300 text-sm md:text-base">
                  {partner.username || "اسم غير متوفر"}
                </td>
                <td className="px-2 py-2 font-[700] border-b border-gray-300 hidden md:table-cell">
                  {partner.city}
                </td>
                <td className="px-2 py-2 font-[700] border-b border-gray-300 hidden md:table-cell">
                  {partner.numberOfAccidents}
                </td>
                <td className="px-2 py-2 border-b border-gray-300">
                  <div
                    className={`w-10 h-5 md:w-12 md:h-6 flex items-center rounded-full p-1 cursor-pointer transition-all duration-300 ${
                      partner.isActive ? "bg-green-500" : "bg-gray-300"
                    }`}
                    onClick={() => toggleStatus(partner.id, partner.isActive)}
                  >
                    <div
                      className={`w-4 h-4 md:w-5 md:h-5 bg-white rounded-full shadow-md transform transition-transform duration-300 ${
                        partner.isActive ? "translate-x-4 md:translate-x-6" : ""
                      }`}
                    ></div>
                  </div>
                </td>
                <td className="px-2 py-2 font-[700] border-b border-gray-300 hidden md:table-cell">
                  {partner.address}
                </td>
                <td className="px-2 py-2 text-center border-b border-gray-300 space-x-1 md:space-x-2">
                  <button
                    onClick={() => handleView(partner.id)}
                    className="text-green-500 hover:text-green-700"
                  >
                    <FaEye className="text-lg md:text-xl" />
                  </button>
                  <button 
                    onClick={() => handleEdit(partner.id)} 
                    className="text-blue-400 hover:text-blue-700"
                  >
                    <BiSolidEdit className="text-lg md:text-xl" />
                  </button>
                  <button 
                    onClick={() => handleDelete(partner.id)} 
                    className="text-red-500 hover:text-red-700"
                  >
                    <RiDeleteBin6Line className="text-lg md:text-xl" />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center py-4">
              Keine Partner verfügbar.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
    
    <Pagination
      totalPages={totalPages}
      currentPage={currentPage}
      onPageChange={handlePageChange}
    />
  </div>
);
}

export default Partner;